/**
 * This app's view of the one password rule, plus the catalogue lookup for it.
 *
 * The rule itself lives in `@erpx/ui` (`ui/src/lib/password.ts`) — the shared
 * home `crypto.MinPasswordLength`'s own comment names, and the only way `web`
 * and `admin` can hold the same policy, since `admin` cannot import from here.
 * It was briefly written out in full in this file and again in
 * `admin/src/lib/credentials.ts`: three hand transcriptions of one security
 * rule, which agree on the day they are written and not afterwards.
 *
 * What stays here is the part that genuinely is this app's — mapping a violation
 * to a key in THIS catalogue. `admin` words the same four refusals differently
 * because its reader is an operator acting on somebody else's account.
 */

export {
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
  passwordPolicyViolation,
  type PasswordPolicyViolation,
} from '@erpx/ui'

import type { PasswordPolicyViolation } from '@erpx/ui'

/** The catalogue key for a violation, so the caller renders it in the user's language. */
export function passwordPolicyKey(violation: PasswordPolicyViolation): string {
  return `common.validation.password.${violation}`
}
